import styled from "styled-components";

export const UnauthorizedContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UnauthorizedLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  color: gray;
  margin: 0 auto;
  max-width: 500px;
  text-align: center;

  & svg {
    margin-top: 5px;
    width: 250px;
  }

  & button {
    margin-top: 50px;
  }
`;
